import React from "react";
import {makeStyles, Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import Tr from "translations/Translations";
import PropTypes from "prop-types";
import AdditionalRoundPassiveRow from "./AdditionalRoundPassiveRow";

const useStyles = makeStyles(theme => ({
    table: {
        border: `solid 3px ${theme.palette.background.paper}`,
        "& .MuiTableCell-root": {
            border: `solid 1px ${theme.palette.border.dark}`,
            padding: theme.spacing()
        }
    },
    headRow: {
        "&>.MuiTableCell-head": {
            textAlign: "center",
            borderBottom: `solid 3px ${theme.palette.primary.main}`
        }
    },
    nameColumn: {
        width: 210
    },
    contractorColumn: {
        width: 250
    }

}));

function AdditionalRoundPassiveTable(
    {
        demandId,
        additionalPassiveRounds,
        working,
        editable
    }) {

    const classes = useStyles();

    return (<Table className={classes.table}>
        <TableHead>
            <TableRow className={classes.headRow}>
                <TableCell className={classes.nameColumn}>{Tr("additional_offer_collection")}</TableCell>
                <TableCell className={classes.contractorColumn}>{Tr("contractor")}</TableCell>
                <TableCell>{Tr('status')}</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {
                additionalPassiveRounds.map((element, index) => (<AdditionalRoundPassiveRow
                    key={element.roundId}
                    demandId={demandId}
                    additionalRound={element}
                    rowNumber={index}
                    working={working}
                    editable={editable}
                />))
            }
        </TableBody>
    </Table>)
}

AdditionalRoundPassiveTable.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    additionalPassiveRounds: PropTypes.array.isRequired,
    editable: PropTypes.bool.isRequired,
    working: PropTypes.bool.isRequired,
}

export default AdditionalRoundPassiveTable;

